module.exports = __webpack_public_path__ + "static/media/ElsieSwashCaps-Regular.74e85a2b.ttf";